import {UI, StyleSheet, styleRule, registerStyle} from "../../../../stem-core/src/ui/UI.js";
import {CheckmarkIcon, MinusIcon} from "../../SVGElements.jsx";
import {MessageElement} from "../../../../blinkpay/widget/ui/MessageElement.jsx";
import {Device} from "../../../../stem-core/src/base/Device.js";
import {BaseInputElement} from "../BaseInputElement.js";


export class CheckboxInputStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
        cursor: "pointer",
        userSelect: "none",
        alignItems: "flex-start",
        lineHeight: this.themeProps.GENERAL_LINE_HEIGHT, // This is needed because this component is used in dashboard.
    };

    @styleRule
    checkbox = {
        position: "relative",
        flexShrink: 0,
        marginTop: ((parseFloat(this.themeProps.GENERAL_LINE_HEIGHT) || 1.5) - 1) / 2 + "em", // Align the checkbox top margin with the text top margin.
        marginRight: 12,
        border: "1px solid " + this.themeProps.MERCHANT_CHECKBOX_BORDER_COLOR,
        borderRadius: this.themeProps.MERCHANT_CHECKBOX_BORDER_RADIUS,
        width: this.themeProps.MERCHANT_CHECKBOX_SIZE,
        height: this.themeProps.MERCHANT_CHECKBOX_SIZE,
        pointerEvents: "none",
        ":hover": {
            cursor: "pointer",
        },
    };

    // Checked or indeterminate
    @styleRule
    selected = {
        backgroundColor: this.themeProps.MERCHANT_CHECKBOX_ENABLED_BACKGROUND_COLOR
    };

    @styleRule
    label = {
        userSelect: "none",
        "-webkit-user-select": "none",
    };

    @styleRule
    disabled = {
        opacity: 0.7,
        pointerEvents: Device.isMobileDevice() ? "none" : "initial",
        cursor: "not-allowed",
    };
}

@registerStyle(CheckboxInputStyle)
export class CheckboxInput extends BaseInputElement {
    getDefaultOptions(options) {
        return {
            ...super.getDefaultOptions(options),
            initialValue: false,
            label: "Label"
        };
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        if (this.options.disabled) {
            // TODO actually implement disabled
            attr.addClass(this.styleSheet.disabled);
        }
    }

    getIcon() {
        const iconOptions = {
            color: this.styleSheet.themeProps.MERCHANT_CHECKBOX_CHECKMARK_COLOR,
            size: "100%",
            style: {display: "block"},
        };

        if (this.getValue() === null) {
            return <MinusIcon {...iconOptions}/>;
        }
        if (this.getValue()) {
            return <CheckmarkIcon {...iconOptions}/>;
        }
        return null;
    }

    render() {
        const {styleSheet} = this;
        const checkboxClass = styleSheet.checkbox + (this.getValue() !== false ? styleSheet.selected : "");
        return [
            <div className={checkboxClass}>
                {this.getIcon()}
            </div>,
            <MessageElement className={styleSheet.label} message={this.options.label}/>,
        ];
    }

    onMount() {
        super.onMount();

        this.addClickListener((event) => {
            event.stopPropagation();
            if (this.getValue() === false) {
                // unchecked -> checked
                this.setValue(true);
            } else {
                // Checked or indeterminate -> unchecked
                this.setValue(false);
            }
        });

        // TODO also handle Enter or Space
        // this.addNodeListener("keyup", event => {
        //     if (this.options.disabled) {
        //         return;
        //     }
        //     const key = new KeyEvent(event);
        //     if (key.isEnter() || key.isSpace()) {
        //         this.setAndDispatchValue(!this.value);
        //     }
        // });
    }
}
